import HttpProxy from '@/services/HttpProxy';

export default class ServiceService {
  static async getAll(textSearch) {
    const apiResponse = await HttpProxy.submit({
      method: 'get',
      url: 'services',
      parameters: {
        textSearch,
      }
    });
    return apiResponse.data ?? null;
  }

  static async getbyId(id) {
    const apiResponse = await HttpProxy.submit({ method: 'get', url: `services/${id}` });
    return apiResponse.data ?? null;
  }

  static async create(payload) {
    const apiResponse = await HttpProxy.submit({ method: 'post', url: 'services', data: payload });
    return apiResponse.data ?? null;
  }

  static async update(id, payload) {
    const apiResponse = await HttpProxy.submit({ method: 'put', url: `services/${id}`, data: payload });
    return apiResponse.data ?? null;
  }

  static async remove(id) {
    const apiResponse = await HttpProxy.submit({ method: 'delete', url: `services/${id}` });
    return apiResponse.data ?? null;
  }
}
